import type { VolumeResponse } from '@onflow/shared';
import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';
import { useMemo } from 'react';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler);

interface Props {
  data: VolumeResponse;
  units: 'KG' | 'LB';
}

export function VolumeChart({ data, units }: Props) {
  const chartData = useMemo(
    () => ({
      labels: data.points.map((p) =>
        new Date(p.weekStart).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }),
      ),
      datasets: [
        {
          label: `Total volume (${units === 'LB' ? 'lb' : 'kg'})`,
          data: data.points.map((p) =>
            units === 'LB'
              ? Math.round(p.totalVolume * 2.20462 * 10) / 10
              : Math.round(p.totalVolume * 10) / 10,
          ),
          tension: 0.3,
          fill: true,
          backgroundColor: 'rgba(0, 122, 255, 0.15)',
          borderColor: '#007aff',
          pointBackgroundColor: '#007aff',
          pointRadius: 3,
        },
      ],
    }),
    [data, units],
  );

  return (
    <div className="chart-wrap" aria-label="Weekly volume over time">
      <Line
        data={chartData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false }, tooltip: { mode: 'index', intersect: false } },
          scales: {
            x: { grid: { display: false } },
            y: { ticks: { maxTicksLimit: 4 } },
          },
        }}
      />
    </div>
  );
}
